module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (Object.keys(_vm.quizzes).length) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.quizzes), function(quiz, key) {
    return _c('div', {
      key: quiz.key,
      staticClass: "col-12 col-sm-6 col-md-4 col-lg-4 mt-3"
    }, [_c('b-card', {
      attrs: {
        "title": quiz.name,
        "sub-title": quiz.questions.length + ' Fragen'
      }
    }, [_c('div', {
      staticClass: "text-right"
    }, [_c('b-button', {
      attrs: {
        "to": {
          name: 'QuizByName',
          params: {
            name: _vm.toUrl(quiz.name)
          }
        }
      }
    }, [_vm._v("Quiz starten")])], 1)])], 1)
  }))]) : _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-fw text-muted"
  }), _vm._v(" Quizzes werden geladen.\n\t\t")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 mt-4"
  }, [_c('h1', [_vm._v("Wähle ein Quiz")]), _vm._v(" "), _c('p', [_vm._v("Durch Fragen besser in Mathe.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-710aaf40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/router/Home.vue
// module id = 713
// module chunks = 1